import { Form } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

const { Input } = Form

/**
 * This is a wrapper for the pay value error tooltip.
 * It is used to position the tooltip correctly.
 */
export const ExtendedInput = styled(Input)`
  &:disabled {
    color: ${({ theme }) => theme.palette.muted};
  }
`
